import { Box, Grid } from '@mui/material';
import logo from '../../assets/images/logo.png';

interface Props {
  landscape: boolean;
}

export default function NavbarMobile({ landscape }: Props) {
  return (
    <>
      <Grid container>
        <Grid item xs={4} pl={1} pt={5} sx={{ zIndex: 1500 }}>
          <Box component={'a'} href="https://kasikorncarabao.com/">
            <img
              src={logo}
              alt="logo"
              width="100"
              style={{
                position: 'relative',
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
